import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { addWindowPadding, clearWindowPadding } from "./scrollbar-padding.js";

gsap.registerPlugin(ScrollTrigger);

document.addEventListener("DOMContentLoaded", () => {
  const mainNav = document.querySelector(".js-header-navigation");
  let menuTransitioning = false;
  let clickOutsideTargetOverlay = null;

  if (mainNav) {
    const navToggle = document.querySelector(".js-nav-toggle");
    const primaryMenu = document.querySelector(".js-primary-menu");
    const offCanvasNav = document.querySelector(".js-off-canvas-nav");
    const logoLink = document.getElementById("site-logo");
    const openStateClass = "is-open";

    if (navToggle && logoLink) {
      navToggle.addEventListener("click", toggleNavState);
      logoLink.addEventListener("click", (e) => {
        e.stopPropagation();
      });
    }

    // Allow clicks 'behind' the Nav bar to be registered
    mainNav.addEventListener("click", function (e) {
      if (clickOutsideTargetOverlay !== null) return;
      mainNav.style.display = "none";
      let elem = document.elementFromPoint(e.clientX, e.clientY);
      if (elem) elem.click();
      mainNav.style.display = "block";
    });

    offCanvasNav.addEventListener("click", function (e) {
      e.stopPropagation();
    });

    /* Click outside to close menu */
    document.addEventListener("click", function (e) {
      if (navToggle.classList.contains(openStateClass)) {
        let clickedInsideOverlay = offCanvasNav.contains(e.target);
        let clickedHeader = mainNav.contains(e.target);

        if (clickedInsideOverlay) return;

        if (clickedHeader) {
          const clickX = e.clientX;
          const maxValidX = window.innerWidth - offCanvasNav.offsetWidth;

          if (clickX <= maxValidX) {
            closeMenu();
            menuTransitioning = true;
          }
          return;
        }

        closeMenu();
        menuTransitioning = true;
      }
    });

    function toggleNavState(e) {
      e.stopPropagation();
      if (!navToggle.classList.contains(openStateClass)) {
        offCanvasNav.classList.add(openStateClass);
        displayMenu();
        offCanvasNav.hidden = false;
        navToggle.classList.add(openStateClass);
        navToggle.setAttribute("aria-expanded", "true");
        navToggle.setAttribute("aria-label", "Close main navigation");
        // addWindowPadding();
        // document.querySelector('body').classList.add('nav-open');
        addClickOutsideTargetOverlay();
      } else {
        closeMenu();
      }
    }

    function resetMenu() {
      offCanvasNav.classList.remove(openStateClass);
      offCanvasNav.hidden = true;
      navToggle.classList.remove(openStateClass);
      navToggle.setAttribute("aria-expanded", "false");
      navToggle.setAttribute("aria-label", "Open main navigation");
      // document.querySelector('body').classList.remove('nav-open');
      gsap.set(navToggle, { clearProps: "all" });
      clearWindowPadding();
      menuTransitioning = false;
    }

    function displayMenu() {
      // let items = [];
      // let primaryMenuItems = primaryMenu.querySelectorAll('[role="menuitem"]');
      // if (primaryMenuItems.length > 0) {
      //     items.push(primaryMenuItems);
      // }

      mainNav.classList.add("nav-open");

      // gsap.set(items, { yPercent: +100 } );

      let tlMenuOpen = gsap.timeline();
      tlMenuOpen
        .to(navToggle, {
          duration: 0.2,
          rotate: 45,
          ease: "power2.inOut",
          onComplete: changeToggleRole,
        })
        .add(() => gsap.set(offCanvasNav, { opacity: 1 }), 0);
      // .to([primaryMenu.querySelectorAll('[role="menuitem"]')],
      //     { duration: 0.38, yPercent: 0, stagger: 0.08, ease: 'power2.inOut' }, 0)
    }

    function closeMenu() {
      menuTransitioning = true;
      if (clickOutsideTargetOverlay) {
        clickOutsideTargetOverlay.remove();
        clickOutsideTargetOverlay = null;
      }
      mainNav.classList.remove("nav-open");
      let tlMenuClose = gsap.timeline();
      tlMenuClose
        .to(navToggle, { duration: 0.3, rotate: 0, ease: "power2.inOut" }, 0)
        // .to([primaryMenu.querySelectorAll('[role="menuitem"]')],
        //     { duration: 0.25, yPercent: +100, stagger: -0.08, ease: 'power2.inOut' }, 0)
        .add(() => gsap.set(offCanvasNav, { opacity: 0 }))
        .add(() => navToggle.classList.remove("exit-mode"))
        .add(() => {
          resetMenu();
        });
    }

    function changeToggleRole() {
      navToggle.classList.add("exit-mode");
      //gsap.set(navToggle, { opacity: 0, rotation: 180 } );
    }

    function addClickOutsideTargetOverlay() {
      clickOutsideTargetOverlay = document.createElement("div");
      clickOutsideTargetOverlay.classList.add("u-click-outside-target-overlay");
      clickOutsideTargetOverlay.setAttribute("aria-hidden", "true");
      mainNav.appendChild(clickOutsideTargetOverlay);
    }
  }
});
